import { render, staticRenderFns } from "./generateToken.vue?vue&type=template&id=21516df8&scoped=true&"
import script from "./generateToken.vue?vue&type=script&lang=js&"
export * from "./generateToken.vue?vue&type=script&lang=js&"
import style0 from "./generateToken.vue?vue&type=style&index=0&id=21516df8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21516df8",
  null
  
)

export default component.exports